import React from 'react';
import styled from 'styled-components';
import { useStoreState } from '../store';
import { useLocale } from '../hooks/useLocale';
import laptopIcon from '../assets/images/laptop.svg';
import phoneIcon from '../assets/images/phone.svg';
import { theme } from '../utils/theme';

/**
 * This component is used to display feedback messages to the user
 * for errors, information, etc.
 */
export function ErrorOverlay() {
  const locale = useLocale();
  const error = useStoreState(state => state.error.error);

  if (!error) return null;

  return (
    <Container>
      <Icon />
      <Header>{locale.translations.ErrorOverlay.ErrorCode(error.code)}</Header>
      <Message>
        {locale.translations.ErrorOverlay.CannotBePlayed}
        <br />
        {locale.translations.ErrorOverlay.PleaseTryAgain}
      </Message>
    </Container>
  );
}
const Container = styled.div`
  padding: 64px 100px;
  border-radius: 4px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12);
  background-image: ${({ theme }) => `linear-gradient(to bottom, ${theme.white}, ${theme.white})`},
    linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) 80%, rgba(0, 0, 0, 0.02) 95%, rgba(0, 0, 0, 0.04));
  z-index: 1;

  @media ${theme.mobileMediaQuery} {
    padding: 58px 24px 44px;
    margin: 25px;
  }
`;

const Header = styled.div`
  font-family: 'Lato', sans-serif;
  font-weight: 900;
  line-height: 1.3;
  letter-spacing: 0.2px;
  text-align: center;
  color: ${({ theme }) => theme.medGray};
  font-size: 20px;
  margin: 24px 0 8px;
`;

const Message = styled.div`
  font-family: 'Lato', sans-serif;
  line-height: 1.43;
  letter-spacing: 0.3px;
  text-align: center;
  color: #aaa8ad;
  font-size: 14px;
`;

const Icon = styled.div`
  width: 250px;
  height: 111px;
  margin: 0 auto;
  background: url(${laptopIcon}) no-repeat center;

  @media ${theme.mobileMediaQuery} {
    width: 216px;
    height: 118px;
    background: url(${phoneIcon}) no-repeat center;
  }
`;
